export const CLASS_NAMES = {
  container: 'flex flex-1 flex-col mt-1 md:mt-4',
  content: 'flex flex-1 flex-col -mr-8',
  titleWrapper: 'flex flex-row justify-between mb-4 relative',
  heading: 'text-style-f-em text-neutral-800 mr-4',
};

export const DESCRIPTION = 'Line Items';
